import { IGetIncorporacaoBlocosByIdListaUseCase } from "../../../presentation/useCases/read/get_incorporacao_blocos_by_id_lista_use_case";
import { IncorporacaoBloco } from "../../models/incorporacao_bloco";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetIncorporacaoBlocosByIdListaUseCase
 */

export class GetIncorporacaoBlocosByIdListaUseCase implements IGetIncorporacaoBlocosByIdListaUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getIncorporacaoBlocosByIdLista(
    idIncorporacaoBlocoLista: number[],
  ): Promise<IncorporacaoBloco[]> {
    return await this.repository.getIncorporacaoBlocosByIdLista(idIncorporacaoBlocoLista);
  }
}
